import React, { useEffect, useState } from 'react';
import { Images } from 'lucide-react';
import { galeriaPublicaService } from '../../api/services';
import { Loading, Vazio } from '../../components/ui';
import type { Imagem } from '../../types';
import './galeria.css';

export default function GaleriaPage() {
  const [imagens, setImagens] = useState<Imagem[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [selecionada, setSelecionada] = useState<Imagem | null>(null);
  const [indice, setIndice] = useState(0);

  useEffect(() => {
    galeriaPublicaService.listar('galeria')
      .then(r => setImagens(r.imagens))
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, []);

  function abrir(img: Imagem, idx: number) {
    setSelecionada(img);
    setIndice(idx);
  }

  function navegar(direcao: number) {
    const novoIndice = (indice + direcao + imagens.length) % imagens.length;
    setIndice(novoIndice);
    setSelecionada(imagens[novoIndice]);
  }

  function fecharLightbox(e: React.KeyboardEvent) {
    if (e.key === 'Escape') setSelecionada(null);
    if (e.key === 'ArrowLeft') navegar(-1);
    if (e.key === 'ArrowRight') navegar(1);
  }

  return (
    <div className="galeria-page" onKeyDown={fecharLightbox} tabIndex={0}>

      <section className="page-header">
        <div className="container">
          <div className="page-header-conteudo">
            <div className="secao-tag">Memórias</div>
            <h1>Galeria</h1>
            <p>Registros fotográficos das atividades e momentos especiais da Liga Cultural de Marabá.</p>
          </div>
        </div>
      </section>

      <section className="galeria-conteudo">
        <div className="container">
          {carregando ? (
            <Loading mensagem="Carregando galeria..." />
          ) : imagens.length === 0 ? (
            <Vazio
              icone={<Images size={48} />}
              titulo="Nenhuma foto cadastrada"
              descricao="Em breve novas fotos serão publicadas aqui."
            />
          ) : (
            <>
              <p className="galeria-total">{imagens.length} foto{imagens.length !== 1 ? 's' : ''}</p>
              <div className="galeria-grid">
                {imagens.map((img, idx) => (
                  <div
                    key={img.id}
                    className="galeria-item"
                    onClick={() => abrir(img, idx)}
                  >
                    <img src={img.urlPublica} alt={img.titulo} loading="lazy" />
                    <div className="galeria-overlay">
                      <p>{img.titulo}</p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Lightbox com navegação */}
      {selecionada && (
        <div className="lightbox" onClick={() => setSelecionada(null)}>
          <button className="lightbox-fechar" onClick={() => setSelecionada(null)}>✕</button>

          {imagens.length > 1 && (
            <>
              <button
                className="lightbox-nav lightbox-prev"
                onClick={e => { e.stopPropagation(); navegar(-1); }}
              >‹</button>
              <button
                className="lightbox-nav lightbox-next"
                onClick={e => { e.stopPropagation(); navegar(1); }}
              >›</button>
            </>
          )}

          <div className="lightbox-conteudo" onClick={e => e.stopPropagation()}>
            <img src={selecionada.urlPublica} alt={selecionada.titulo} />
            <div className="lightbox-rodape">
              <p className="lightbox-titulo">{selecionada.titulo}</p>
              {imagens.length > 1 && (
                <span className="lightbox-contador">{indice + 1} / {imagens.length}</span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}